import { FC } from 'react';
import { StoreReviewDataType } from '../../../../types/StoreTypes';
import StoreReview from './StoreReview';
import S from './StoreReviewList.module.scss';

/**
 * 에셋 리뷰 리스트를 관리하는 컴포넌트
 */
const StoreReviewList: FC<StoreReviewListProps> = ({
  reviewList
}: StoreReviewListProps) => {
  return <>
      <div className={S.review_container}>
        {reviewList.map(review => <StoreReview key={review.hashId} review={review} />)}
      </div>
    </>;
};
export default StoreReviewList;
export type StoreReviewListProps = {
  reviewList: StoreReviewDataType[];
};